import type { AxiosRequestConfig } from "axios";
import type { IRepositoryOptions } from "@/types/common";
import type { ICompanyChangeRequest } from "@/types/company-change-request";
import { BaseRepository } from "../BaseRepository";
import type { CompanyChangeService } from "./service";
import type {
  IFlagCompanyWrongRequest,
  IGetUserRequestsRequest,
  IProcessRequestRequest,
  IRequestCompanyChangeRequest,
} from "./types";

export class CompanyChangeRepository extends BaseRepository {
  constructor(
    private readonly service: CompanyChangeService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getPendingRequests(
    c?: AxiosRequestConfig,
  ): Promise<ICompanyChangeRequest[]> {
    const response = await this.handleRequest(
      this.service.getPendingRequests,
      c,
    );
    return response.data;
  }

  async getUserRequests(
    p: IGetUserRequestsRequest,
    c?: AxiosRequestConfig,
  ): Promise<ICompanyChangeRequest[]> {
    const response = await this.handleRequest(
      this.service.getUserRequests,
      p,
      c,
    );
    return response.data;
  }

  async getCurrentUserRequests(
    c?: AxiosRequestConfig,
  ): Promise<ICompanyChangeRequest[]> {
    const response = await this.handleRequest(
      this.service.getCurrentUserRequests,
      c,
    );
    return response.data;
  }

  async flagWrong(
    p: IFlagCompanyWrongRequest,
    c?: AxiosRequestConfig,
  ): Promise<ICompanyChangeRequest> {
    const response = await this.handleRequest(this.service.flagWrong, p, c);
    return response.data;
  }

  async requestChange(
    p: IRequestCompanyChangeRequest,
    c?: AxiosRequestConfig,
  ): Promise<ICompanyChangeRequest> {
    const response = await this.handleRequest(this.service.requestChange, p, c);
    return response.data;
  }

  async processRequest(
    p: IProcessRequestRequest,
    c?: AxiosRequestConfig,
  ): Promise<ICompanyChangeRequest> {
    const response = await this.handleRequest(
      this.service.processRequest,
      p,
      c,
    );
    return response.data;
  }
}
